<template>
  <tr>
    <td>
      <div class="project_types">
        <template v-if="item.project_types.length">
          <div v-for="(project_type, index) in item.project_types" :key="index">
            {{ project_type.name }}
          </div>
        </template>
        <span v-else>{{ localStorage.translations.pages.common.text['net-dannyh'] }}</span>
      </div>
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      <div class="buttons">
        <WorkTypeCategoryModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_type',
            })
          "
          :create="false"
          :id="item.id"
        />
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_type',
            })
          "
          :item="item"
          :text="
            localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
              'udalit-kategoriyu-rabot'
            ] +
            ' ' +
            item.name
          "
          :textSecond="
            localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
              'dlya-udaleniya-kategorii-rabot'
            ] +
            ' ' +
            item.name +
            localStorage.translations.pages['setting-work_type_category']['dialog-delete'][
              'neobhodimo-udalit-svyazi'
            ]
          "
          :textCheckbox="localStorage.translations.pages['common']['checkbox']['delete_all_links']"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkTypeCategoryModal from 'components/setting/workTypeCategory/WorkTypeCategoryModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkTypeCategoryTableItem',
  components: { WorkTypeCategoryModal, DeleteModal },
  props: ['item'],
}
</script>
